'use client';

import { useClickWithAnalytics } from '@/analytics/useClickWithAnalytics';
import { Button, ButtonProps } from '@soluto-private/mx-asurion-ui-react';
import type { FunctionComponent } from 'react';

export const ButtonWithAnalytics: FunctionComponent<ButtonProps> = ({
  children,
  onClick,
  ...props
}) => (
  <Button
    color="secondary"
    {...props}
    onClick={useClickWithAnalytics('ButtonClick', onClick)}
  >
    {children}
  </Button>
);
